import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";
import { ConfigureStyled } from "../../reports/view/inventory/InventoryStyled";
import COVA_WEB_CONFIG_IMG from "assets/images/cova_web_config.png";
import WebAppLink from "components/blocks/link/WebAppLink";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { RecorderConfig } from "api/interfaces/recorderInterface.interface";
import { FaInfo, FaInfoCircle } from "react-icons/fa";

type Props = {
  onModal: () => void;
  configureInfo: RecorderConfig;
};

export default function CovaConfiguration(props: Props): JSX.Element {
  const { accountId, accountLevel }: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  // const recorderId = "{b27b8e74-0e53-45b6-5078-5348f437d58a}";
  const recorderId = props.configureInfo.recorderId;

  return (
    <SmallPopupTemplate
      title="How to Import COVA Configuration"
      onClick={props.onModal}
      onModal={props.onModal}
      confirmLabel="OK"
      data-testid="recorders-configuration-configuration-small-popup-template-modal"
    >
      <ConfigureStyled.Description>
        <FaInfoCircle />
        myDW registration process is required after restore all configuration at
        COVA system
      </ConfigureStyled.Description>
      <ConfigureStyled.Inner>
        <h3>
          You can import the configuration file into COVA from the path below.
        </h3>
        <ol className="setting">
          {accountLevel === LEVEL_TYPE.EU && (
            <li>
              <WebAppLink
                type="COVA"
                accountId={accountId}
                recorderId={recorderId}
                mergedSystemId={recorderId}
                isCovaConfigure
              />
            </li>
          )}

          <li>
            Settings &gt; <b>Utility</b>
          </li>
          <li>
            <div className="import-system">
              <span>
                Attach the configuration file you downloaded in the{" "}
                <b>'Import System Configuration’</b> section.
              </span>
              <div className="config-bg">
                <img src={COVA_WEB_CONFIG_IMG} alt="cova-web-config-info" />
              </div>
            </div>
          </li>
        </ol>
      </ConfigureStyled.Inner>
    </SmallPopupTemplate>
  );
}
